import { ITransactionDetailsOrder, ITransactionDetailsInstallationDate, ITransactionDetailsCancelable, ITransactionDetailsCustomer, ITransactionDetailsFtth, ITransactionDetailsAddresses, ITransactionDetailsInstallerLocations } from "./types";


export default class TransactionDetailsFtth implements ITransactionDetailsFtth {

  order: ITransactionDetailsOrder;
  customer: ITransactionDetailsCustomer;
  addresses: ITransactionDetailsAddresses;
  transaction: ITransactionDetailsCancelable;
  installationDate: ITransactionDetailsInstallationDate;
  installerPosition:  ITransactionDetailsInstallerLocations;


  constructor(
    order: ITransactionDetailsOrder,
    customer: ITransactionDetailsCustomer,
    addresses: ITransactionDetailsAddresses,
    transaction: ITransactionDetailsCancelable,
    installationDate: ITransactionDetailsInstallationDate,
    installerPosition: ITransactionDetailsInstallerLocations
  ) {
    this.order = order;
    this.customer = customer;
    this.addresses = addresses;
    this.transaction = transaction;
    this.installationDate = installationDate;
    this.installerPosition = installerPosition;
  }

}
